import { QueryClientProvider } from "@tanstack/react-query";
import type { QueryClient } from "@tanstack/react-query";
import type { ReactNode } from "react";

/*
 * Provedores globais do app (FE-0 CP-D — ADR 0026).
 *
 * Hoje envolve apenas o `QueryClientProvider` (server-state). O `RouterProvider`
 * é montado em `main.tsx` POR FORA destes provedores: o router precisa do
 * QueryClient disponível na árvore, então `<Providers>` envolve o
 * `<RouterProvider>`. Mantido como componente fino e testável.
 *
 * `queryClient` é injetável para teste; em produção, `main.tsx` cria um único
 * client estável com `criarQueryClient()`.
 */
export function Providers({
  children,
  queryClient,
}: {
  children: ReactNode;
  queryClient: QueryClient;
}): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
